import { render } from "./User.vue?vue&type=template&id=88d5f004"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import exportComponent from "/home/viapanelqualisof/admin.exchange.qualisoft.biz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__